var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"empty:hidden content-wrapper"},_vm._l((_vm.teaserData),function(payload,index){return _c('StTeaserImageText',{key:index,attrs:{"payload":payload.data,"meta":_vm.meta}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }